// Icon Component
// Reusable wrapper for Lucide React icons with variant support

import React from 'react';
import { LucideIcon } from 'lucide-react';
import { ComponentProps } from 'react';
import styled from 'styled-components';

export interface IconProps extends Omit<ComponentProps<LucideIcon>, 'icon'> {
  icon: LucideIcon;
  variant?: 'default' | 'filled' | 'outline';
  size?: number;
  className?: string;
}

const IconWrapper = styled.span<{ $variant?: 'default' | 'filled' | 'outline' }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  
  svg {
    ${({ $variant }) => $variant === 'filled' && `
      fill: currentColor;
    `}
  }
`;

export const Icon: React.FC<IconProps> = ({ 
  icon: IconComponent, 
  variant = 'default',
  size = 24,
  className,
  ...props 
}) => {
  return (
    <IconWrapper $variant={variant} className={className}>
      <IconComponent 
        size={size}
        {...props}
      />
    </IconWrapper>
  );
};

